import { useEffect, useState } from "react";
import {CRM} from "../../../services/API/CRM";
import Layout from '../../Frames/Layout'
import Profile from './Profile';
import Enrollments from './Enrollments/List';
import Activities from '../Activities/Index';
import Teacher from './Teacher/Index';
import '../../../css/person.css';
import Business from "./Business";
import { Navigate, useParams } from "react-router-dom";
import Loader from '../../Tools/Loader'
import { Stack, Alert } from "@mui/material";
import Cards from "./Cards";
import Affiliates from "./Affiliates";
import StudentProof from "./StudentProof";
import Sponsor from "./Sponsor";

export default function Index(){

    const {id} = useParams();

    const [person, setPerson] = useState(null)

    useEffect(() => {

        if(!id.startsWith('prospect_')){

            CRM.getPerson(id)
                .then(r => setPerson(r.data))
                .catch(e => setPerson(false))
        }

    }, [id])


    if(id.startsWith('prospect_')){
        return <Navigate to={'/crm/prospects/' + id.split('_').pop()} />
    }


    return <Layout tab="persons" menu="crm">

        {person && 

            <Stack direction='column' spacing={2} sx={{pt: 2, pb: 2}}>

                <Profile person={person} />

                <Cards person={person} />

                <Stack direction="row" gap={1} flexWrap="wrap">
                    <StudentProof person={person} />
                    <Sponsor person={person} />
                </Stack>

                <Enrollments person={person}/>

                <Affiliates person={person}/>

                {person.profile?.id === 'teacher' && 
                    <Teacher person={person} />
                }

                {['business','admin'].includes(person.profile?.id) && 
                    <Business person={person}/>
                }

                {['student','company','teacher'].includes(person.profile?.id) && 
                    <Activities person={person}/>
                }

            </Stack>
        }

        {person === null && <Loader />}

        {person === false &&
            <Alert severity='warning' sx={{mt: 3}}>Contact introuvable</Alert>
        }
    
    </Layout>
}
